import { graphql, useStaticQuery } from 'gatsby';
import { ContentfulReview } from 'utils/types';

type Review = Pick<
  ContentfulReview,
  | 'product_page_id'
  | 'product_name'
  | 'average_rating'
  | 'rating_histogram'
  | 'review_count'
  | 'recommended_ratio'
  | 'contents'
>;

export default function usePowerReviewsById(productId: string) {
  const { allReviews } = useStaticQuery<{
    allReviews: {
      nodes: Review[];
    };
  }>(graphql`
    query {
      allReviews {
        nodes {
          product_name
          product_page_id
          average_rating
          rating_histogram
          review_count
          recommended_ratio
          contents {
            comments
          }
        }
      }
    }
  `);

  const foundReview = allReviews.nodes.find(
    (review) => review.product_page_id === productId,
  );

  if (!foundReview) {
    return {
      averageRating: 0,
      reviewCount: 0,
      recommendedRatio: 0,
      ratingHistogram: [0, 0, 0, 0, 0],
      contents: [],
    };
  }

  return {
    name: foundReview.product_name,
    productId: foundReview.product_page_id,
    averageRating: foundReview.average_rating,
    reviewCount: foundReview.review_count,
    recommendedRatio: foundReview.recommended_ratio,
    ratingHistogram: foundReview.rating_histogram,
    contents: foundReview.contents,
  };
}
